import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-newsigner',
    templateUrl: './new-signer.component.html',
    styleUrls: ['./new-signer.component.css'],
    standalone: false
})
export class NewsignerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
